import { render, staticRenderFns } from "./adoptAgreement.vue?vue&type=template&id=68075bb8"
import script from "./adoptAgreement.vue?vue&type=script&lang=js"
export * from "./adoptAgreement.vue?vue&type=script&lang=js"
import style0 from "./adoptAgreement.vue?vue&type=style&index=0&id=68075bb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports